// Import _extra.ts from components folder
import { extra } from "./components/_extra";

// Call the extra function
extra();

// console.log("Hello from main!");
